var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenantportLockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 406.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #387c88;\n      }\n\n      .cls-2 {\n        fill: #2c626b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.33,11.31c-14.16,4.94-27.61,11.41-40.15,19.2l28.36,16.64c11.37-6.59,23.52-11.98,36.27-16.01l-24.48-19.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.91,69.91c-9.87,11.34-18.51,23.79-25.69,37.13l32.96,8.01c6.69-11.76,14.64-22.71,23.68-32.65l-30.94-12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.76,113.76c-6.61,13.44-11.78,27.72-15.3,42.64l33.7,3.18c3.41-13.26,8.27-25.94,14.4-37.85l-32.8-7.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.42,267.81c4.82,14.44,11.21,28.16,18.98,40.95l29.69-10.37c-6.87-11.51-12.5-23.84-16.72-36.81l-31.95,6.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.41,216.41c.97,15.3,3.63,30.15,7.8,44.34l32.01-6.24c-3.58-12.74-5.81-26.04-6.53-39.75l-33.28,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.08,304.77l-29.65,10.36c8.26,12.54,17.88,24.11,28.64,34.5l26.57-13.85c-9.61-9.35-18.19-19.75-25.56-31.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.78,354.94c11.01,9.86,23.11,18.54,36.09,25.83l22.87-16.53c-11.65-6.53-22.5-14.31-32.39-23.14l-26.56,13.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.47,166.8l-33.59-3.17c-2.55,12.85-3.89,26.14-3.89,39.75,0,1.91.03,3.81.08,5.71l33.38-1.65c0-.78-.03-1.57-.03-2.35,0-13.13,1.4-25.93,4.04-38.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.43,50.45c-10.9-9.56-22.82-17.97-35.59-25.05l10.3,24.81c10.61,6.62,20.5,14.28,29.51,22.87l-4.22-22.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.41,51.49l-28.12-16.51c-12.43,8.44-23.87,18.22-34.13,29.13l31.14,12.57c9.4-9.48,19.83-17.94,31.11-25.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.71,20.14c-12.87-6.22-26.5-11.12-40.71-14.53l15.61,24.26c12.27,3.55,24.01,8.36,35.07,14.27l-9.97-24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.01.57c-14.96,1.12-29.47,3.85-43.36,8.03l24.75,20.05c12.45-3.27,25.41-5.24,38.75-5.8L188.01.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.96,151.11c-4.34-16.35-10.65-31.89-18.69-46.35l-2.05,19.25c5.63,11.33,10.12,23.31,13.32,35.83l7.42-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M398.87,259.57c3.81-13.29,6.31-27.13,7.33-41.38l-8.23-4.16c-.54,11.1-2.06,21.95-4.5,32.45l5.39,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.87,304.46c6.17-10.75,11.39-22.13,15.54-34l-5.07-12.31c-3.08,10.14-7.02,19.91-11.73,29.22l1.26,17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M398.18,205.9l8.44,4.27c.07-2.26.12-4.52.12-6.8,0-14.91-1.6-29.44-4.65-43.43l-7.51,8.84c2.37,11.73,3.62,23.87,3.62,36.3,0,.28,0,.55-.01.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.88,3.46C228.72,1.19,216.19,0,203.37,0,201.39,0,199.43.03,197.47.09l20.45,22.63c13.12.15,25.91,1.68,38.22,4.46l-15.26-23.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375,94.24c-8.18-12.84-17.76-24.69-28.52-35.35l4.42,23.66c8.37,9.22,15.79,19.3,22.15,30.09l1.96-18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.69,397.64c13.02-4.04,25.49-9.35,37.24-15.79l6.4-18.99c-10.43,6.06-21.51,11.12-33.11,15.05l-10.54,19.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.08,344.2c8.59-8.95,16.37-18.67,23.22-29.07l-1.19-16.03c-5.65,9.38-12.13,18.2-19.33,26.38l-2.71,18.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.53,406.53c14.21-.63,28.05-2.72,41.35-6.12l10.4-19.48c-11.92,3.28-24.32,5.37-37.08,6.16l-14.67,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.28,383.79l-18.84,18.4c13.78,2.96,28.07,4.53,42.73,4.54l14.57-19.31c-.64,0-1.28.02-1.93.02-12.51,0-24.73-1.26-36.53-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.58,376.21c11.03-6.86,21.36-14.74,30.85-23.52l2.59-17.91c-8.23,8.13-17.22,15.49-26.87,21.95l-6.57,19.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.06,384.63c12.91,6.58,26.61,11.83,40.92,15.56l18.78-18.34c-12.87-3.27-25.2-7.92-36.82-13.76l-22.89,16.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: 158,
    height: 90,
    transform: "translate(124.08 31.12) scale(.48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ4AAABaCAYAAABJ/O/ZAAAACXBIWXMAABcRAAAXEQHKJvM/AAAC8klEQVR4nO3cS3LbMBBFUTCrytI8yNADL827sgepjimG4k8A0e/h3rHL6kad8pfCVGi1338+vvY+5vP9bbpjFsc4uFlHsC0D37WGP7Qr2JaB73zDHlgNcPPAd66hDqs2tmXgO579QbXGthYA97M9oB7g5oFvO6vD6Y1tGfieZ3Ew2cDNA996soeSGdtaAHxM6jDUsC0D308SB6EObh74/pb2EJywLQNfMnjO2NYaGWCaxUdDF42Kr/vSo4KbNyK+bgsD7rHR8N2+LOC2GwXgbUsC7ngj4Gu+IOCu5Y6v2XKAez1nfNUXA1zdXPFVWwpwbXMD+PIygLsvJ3yXFwFcn1zwnV4CcP1zwHd4AcDlSxng7uCAy50qvqdDA04nRXz/DQw4zdTw/RsWcB6pAJwA55cCvl+9B6D6KXwxmUrRGJTOl/krHz/jmZcVH7/VDlI2gPwdb6Ay4dscBHx+ZcF3aAgAepUB36kBAOhVT4CXXhiAPvXCx4Og1AUfj75TKeV+fLzZhx66C2DVFwGfR3fga/ICANSvNb6mnxyA2rXEx90ptFsLgNwWRYeqjY/78ehwNfFxIyidqha+rv8sBp9mNfB1f0qhFACq9grAFPAiAOp1FV8qeKWAT7Er+NLBiwCo1Vl8aeFFANTqKMD08CIA6nQEnwy8UsCn1B4+KXgRADXawicJLwKgRmsApeGVAj6Vlvjk4UUAzN8cnw28CIC5C3x28EoBX/Y+398mS3gRAHNl/a12LQD269mfVIaAFwHwnuz+c1Ej8LXJ7iGBVgHw9WweBO0RAM9l8Z6LLIFvO+n31SoEwJ+kr7BQbWSAkrdFOTUSPsmLGd1zBih3B/KIuQDMcON7KcA7nSrALOCiVMOopIIvG7Z5aQdTKCvAzOCi9AMqlAWgArhIZtDs9cSnBC6SGzh7dwJUBBfJDp69lgCVwUXyC2SvFkAHbPOslsnaK/jcwEWWS2XtDEBXcJH1clnbAugOLhpiyYyt4RsFHVG3vgGvJGKlMiaDpAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.48,103.23l-51.62-20.83c-9.04,9.94-16.99,20.89-23.68,32.65l55.59,13.5c5.68-9.13,12.29-17.61,19.71-25.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.87,135.16l-55.32-13.44c-6.13,11.92-10.99,24.59-14.4,37.85l57.13,5.4c3.15-10.46,7.39-20.44,12.59-29.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.73,251.17l-53.36,10.4c4.22,12.97,9.85,25.3,16.72,36.81l48.91-17.09c-5.11-9.48-9.25-19.57-12.28-30.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.86,212l-56.17,2.77c.72,13.7,2.95,27.01,6.53,39.75l53.65-10.46c-2.43-10.32-3.8-21.04-4.01-32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.71,287.78l-48.62,16.99c7.37,11.27,15.95,21.67,25.56,31.02l42.65-22.23c-7.4-7.86-13.97-16.49-19.59-25.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.7,319.02l-42.36,22.07c9.89,8.84,20.75,16.61,32.39,23.14l35.32-25.53c-9.14-5.67-17.63-12.27-25.35-19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.31,172.16l-56.84-5.37c-2.64,12.34-4.04,25.15-4.04,38.28,0,.79.02,1.57.03,2.35l56.42-2.78c.31-11.17,1.83-22.04,4.43-32.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.19,97.31l-4.53-24.24c-9.01-8.59-18.9-16.25-29.51-22.87l12.66,30.49c7.62,4.91,14.76,10.48,21.37,16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.41,78.49l-45.99-26.99c-11.28,7.25-21.71,15.7-31.11,25.19l51.88,20.94c7.71-7.21,16.15-13.63,25.22-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.29,74.5l-12.61-30.35c-11.06-5.91-22.8-10.72-35.07-14.27l21.65,33.66c9.07,2.86,17.78,6.55,26.03,10.97Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 145,
    height: 79,
    transform: "translate(169.2 22.48) scale(.48)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAABPCAYAAADr7Cd8AAAACXBIWXMAABcRAAAXEQHKJvM/AAAClklEQVR4nO3cTXbbMAxF4aeeLqpLy6DDDLq07KqdVD1pa1siCYIAeO8CbMD+JCfyzyHSt+8/fo7exsf722ExS8ZKL26Bo6VdIaVf2hvKVTtCSrFwNChX7QYpxLLZkNxpJ0iui1bE8qpdIE1dcjc0j9oB0lerGwLMvnUfJaC5X/Wz0a3lADNeZUj/LQaYeVWFdIDGt4qQvqweYLcqHrSHVHOx6FU6I/1ZBEj+VYH01xJA8q8CJP47C1B2SE+HB5NfZRFJQPIsM6TLwYHkV1ZIvO0RrIyQmgYGk0/ZIDUPCySfMkHqGhRIPmWBxOeJgpcB0tCAQPIpOiST4cA0v8iQzAYD0vyiQjL7PFHUBWl+5k88Z6S5RTxYpw0EpnlFg8SXF5MWCdL0QYA0ryiQXIYA0rwiQOIHHQq0GpL7nQNpTishLbljIM1pFaRleoE0pxWQln0DdvXrONkV4onkrGSb9wEaApEEJOs8IYVBJAHJOi9IoRBJQLLOA1I4RGdgsms2pLCIJCBZNhNSaEQSkCybBSk8IglIls2AlALRGZhssoaUCpEEJKssIaX74U/eLolX2ieEM9J4VgdkWkRnYBrLAlJ6RBKQRhuFVAKRBKTRRiCVQSQBabReSKUQSUAarQdSOURnYOqvFVJZRBKQRmqBVBqRBKSR7kJKd8W6Na5wz2+rB5izUnt3DsKtEElA6ukK0naIJCD19ArSlogkIPX0DNK2iM7A1NYjSNsjkoDU2r+QQPQ7ILX1GRKIPgWktk5IIHoQmO738f52lL9i3RNXudviwXoRZ6R7geii6pD4jLVT2SBt+yNXGYqCKdrfbKGGyZAXpGhQXpVm0EhZQsqE5VnpF1hVD6QKYB5VcinPnmGqCoZoSr8AnjEn8U3HQosAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388.35,164.77l4.19-4.93c-3.19-12.51-7.69-24.5-13.32-35.83l-1.55,14.58c4.33,8.31,7.92,17.06,10.68,26.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.41,241.45l2.07,5.02c2.44-10.5,3.96-21.34,4.5-32.45l-3.14-1.59c-.22,9.94-1.39,19.63-3.42,29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.98,278.85l.63,8.52c4.72-9.31,8.65-19.08,11.73-29.22l-2-4.86c-2.69,8.89-6.17,17.44-10.36,25.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.79,204.18l3.39,1.72c0-.27.01-.55.01-.82,0-12.43-1.25-24.57-3.62-36.3l-3.9,4.59c2.38,9.93,3.79,20.23,4.12,30.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.65,60.61l-21.5-33.43c-12.31-2.78-25.1-4.31-38.22-4.46l30.64,33.91c9.97.4,19.7,1.75,29.09,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.43,127.75l1.61-15.13c-6.36-10.79-13.78-20.87-22.15-30.09l4.5,24.09c5.93,6.55,11.3,13.62,16.04,21.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.41,355.07l-12.18,22.83c11.61-3.92,22.68-8.98,33.11-15.05l6.42-19.04c-8.65,4.59-17.8,8.38-27.35,11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.71,312.15l-1.93,13.33c7.2-8.18,13.67-17,19.33-26.38l-.66-8.86c-4.92,7.81-10.53,15.14-16.75,21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.52,361.49l-19.32,25.61c12.76-.79,25.17-2.88,37.08-6.16l12.42-23.27c-9.74,2.24-19.83,3.55-30.19,3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.43,357.28l-27.15,26.51c11.8,2.4,24.02,3.66,36.53,3.66.64,0,1.28-.02,1.93-.02l19.6-25.98c-10.61-.34-20.95-1.77-30.91-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.38,338.25l-6.23,18.48c9.65-6.46,18.64-13.82,26.87-21.95l2.01-13.91c-6.98,6.47-14.56,12.29-22.65,17.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.98,342.76l-35.03,25.32c11.62,5.85,23.94,10.49,36.82,13.76l27.44-26.79c-10.24-3.09-20.02-7.23-29.23-12.29Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M542.43,149.33h-50.9v-31.06h135.22v31.06h-50.9v139.66h-33.41v-139.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.19,224.51c0-39.16,28.71-67.87,69.44-67.87s68.92,28.71,68.92,67.87v10.96h-105.72c4.18,18.79,18.53,28.71,36.81,28.71,13.83,0,24.02-3.92,30.54-12.27h33.15c-9.66,24.54-33.15,40.46-63.69,40.46-40.72,0-69.44-28.71-69.44-67.87ZM730.64,210.68c-4.96-17.23-19.06-25.85-36.02-25.85s-31.06,8.87-36.02,25.85h72.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.9,221.9c0-43.07,25.58-65.26,63.69-65.26s63.69,21.93,63.69,65.26v67.09h-31.06v-67.09c0-24.54-13.05-36.29-32.63-36.29s-32.63,11.75-32.63,36.29v67.09h-31.06v-67.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.66,225.82c0-40.99,28.71-69.18,69.7-69.18s68.66,27.41,68.66,68.91v63.43h-28.45v-25.32c-7.83,19.06-25.32,28.71-45.68,28.71-31.32,0-64.21-22.45-64.21-66.56ZM1038.95,224.51c0-22.71-15.14-38.9-37.85-38.9s-38.11,16.18-38.11,38.9,15.4,38.9,38.11,38.9,37.85-16.19,37.85-38.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.6,221.9c0-43.07,25.58-65.26,63.69-65.26s63.69,21.93,63.69,65.26v67.09h-31.06v-67.09c0-24.54-13.05-36.29-32.63-36.29s-32.63,11.75-32.63,36.29v67.09h-31.06v-67.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.58,239.39v-125.04h31.06v45.68h66.57v28.19h-66.57v51.17c0,17.23,8.88,24.02,21.67,24.02s21.67-6.53,21.67-24.02v-3.4h31.06v3.4c0,35.76-21.41,52.99-52.73,52.99s-52.73-17.23-52.73-52.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.58,118.27h69.7c44.38,0,64.22,24.54,64.22,57.95s-19.84,57.95-64.22,57.95h-36.29v54.82h-33.41V118.27ZM1448.81,203.37c22.19,0,29.76-11.48,29.76-27.15s-7.57-26.89-29.76-26.89h-36.81v54.04h36.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525.56,224.51c0-39.16,28.71-67.87,69.44-67.87s69.44,28.71,69.44,67.87-28.71,67.87-69.44,67.87-69.44-28.71-69.44-67.87ZM1632.85,224.51c0-22.71-15.14-38.9-37.85-38.9s-38.11,16.18-38.11,38.9,15.4,38.9,38.11,38.9,37.85-16.19,37.85-38.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.8,214.07c0-38.9,22.97-57.43,56.65-57.43s56.39,18.53,56.39,57.95v.78h-30.8v-1.3c0-20.88-10.44-28.45-25.58-28.45s-25.58,7.57-25.58,28.45v74.92h-31.06v-74.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.54,239.39v-125.04h31.06v45.68h66.57v28.19h-66.57v51.17c0,17.23,8.87,24.02,21.67,24.02s21.67-6.53,21.67-24.02v-3.4h31.06v3.4c0,35.76-21.41,52.99-52.73,52.99s-52.73-17.23-52.73-52.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantportLockup);
export default __webpack_public_path__ + "static/media/tenantport-lockup.a397289a0a5829b70b70d8f49b874f3f.svg";
export { ForwardRef as ReactComponent };